import { Component } from "react";
import PropTypes from "prop-types";

export default class RecordLoader extends Component {
  static propTypes = {
    fetch: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    children: PropTypes.element.isRequired,
    match: PropTypes.shape({})
  };

  state = {
    loading: false
  };

  componentWillMount() {
    const { fetch, id } = this.props;

    this.setState({ loading: true });
    fetch(id).then(() => this.setState({ loading: false }));
  }

  // Required for us to navigate to another record when only the ID in the path is changing.
  // Eg: /users/10 -> /users/11
  componentWillReceiveProps({ match }) {
    const { fetch, id } = this.props;
    const newId = match.params.id;

    if (newId !== id) {
      this.setState({ loading: true });
      fetch(newId).then(() => this.setState({ loading: false }));
    }
  }

  render() {
    if (this.state.loading) {
      return false;
    }

    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./app/modules/shared/containers/RecordLoader/RecordLoader.jsx